import Pagination from '../vc-pagination/locale/zh_CN'
import DatePicker from '../date-picker/locale/zh_CN'
import TimePicker from '../time-picker/locale/zh_CN'
import Calendar from '../calendar/locale/zh_CN'

export default {
  locale: 'zh-cn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: '筛选',
    filterConfirm: '确定',
    filterReset: '重置',
    emptyText: '暂无数据',
    selectAll: '全选当页',
    selectInvert: '反选当页',
    sortTitle: '排序',
  },
  Modal: {
    okText: '确定',
    cancelText: '取消',
    justOkText: '知道了',
  },
  Popconfirm: {
    cancelText: '取消',
    okText: '确定',
  },
  Transfer: {
    notFoundContent: '无匹配结果',
    searchPlaceholder: '请输入搜索内容',
    itemUnit: '项',
    itemsUnit: '项',
  },
  Select: {
    notFoundContent: '无匹配结果',
  },
  Upload: {
    uploading: '文件上传中',
    removeFile: '删除文件',
    uploadError: '上传错误',
    previewFile: '预览文件',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/zh_CN.js